import { render, staticRenderFns } from "./AvaluosMejorasInfo.vue?vue&type=template&id=4e6eb6b0"
import script from "./AvaluosMejorasInfo.vue?vue&type=script&lang=js"
export * from "./AvaluosMejorasInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6eb6b0')) {
      api.createRecord('4e6eb6b0', component.options)
    } else {
      api.reload('4e6eb6b0', component.options)
    }
    module.hot.accept("./AvaluosMejorasInfo.vue?vue&type=template&id=4e6eb6b0", function () {
      api.rerender('4e6eb6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/info_procesos/AvaluosMejorasInfo.vue"
export default component.exports